import {
  validateRole,
  validateInformation,
  validateLicense,
  validateHospital,
  validateAddress,
  validateAccount,
  validateLaboratory,
  validatePetition,
  validateLaboratorySelect,
} from "../UserManagementHelper";
import * as adminApi from "../../../../service/adminApi";

export const CheckUserData = (data) => {
  if (!data) {
    return "ไม่พบข้้อมูล";
  } else {
    return {
      pname: data.prefix,
      fname: data.firstName,
      lname: data.lastName,
      pid: data.id_card.replace(/-/g, ""),
      phone_number: data.phone_number,
      gender: data.gender,
    };
  }
};

export const CheckUsername = (data, role) => {
  if (!data) {
    return "ไม่พบข้้อมูล";
  } else {
    return {
      username: data.username,
      password: data.password,
      role: [role],
      confirm_password: data.confirm_password,
    };
  }
};

export const CheckAddress = (data) => {
  if (!data) {
    return "ไม่พบข้้อมูล";
  } else {
    return {
      current_address: {
        address: data.address,
        village_number: data.village_number,
        building: data.building,
        sub_district_id: data.sub_district_id,
        district_id: data.district_id,
        health_area: data.health_area,
        province_id: data.province_id,
        post_code: data.post_code,
      },
      password: data.password,
      confirm_password: data.confirm_password,
    };
  }
};

export const CheckLaser = (data) => {
  const birthday = data.birthday
    ? new Date(data.birthday).toLocaleDateString("en-CA")
    : "";
  if (!data) {
    return "ไม่พบข้้อมูล";
  } else {
    return {
      birthday_fill: birthday,
      // laser: data.laser,
    };
  }
};

export const CheckMedical = (data, role) => {
  const license = data?.licenses[role] || {};
  if (!data) {
    return "ไม่พบข้้อมูล";
  } else {
    return {
      license_number: license.licenseNumber,
      medical_type: license.medicalType,
      hospital_id: data.hospital_id,
    };
  }
};

export const CheckHospital = (data) => {
  if (!data) {
    return "ไม่พบข้้อมูล";
  } else {
    return {
      hospital_id: data.hospital_id,
    };
  }
};

export const CheckStaffRole = (data, role) => {
  if (!data) {
    return "ไม่พบข้อมูล";
  }
  const roleData = data?.petition[role] || {};

  return {
    staff_role: [
      roleData.analyst && "ANALYST",
      roleData.approver && "APPROVER",
    ].filter(Boolean),

    ...(role === "LABORATORY_ADMIN"
      ? {
          laboratory: {
            laboratory_name: data.laboratory_name || "",
            current_address: {
              address: data.laboratory_address || "",
              village_number: data.laboratory_moo || "",
              alley: data.laboratory_soy || "",
              road: data.laboratory_road || "",
              sub_district_id: data.laboratory_subDistrict || "",
              post_code: data.laboratory_postCode || "",
            },
            location: {
              latitude: data.latitude || "",
              longitude: data.longitude || "",
            },
          },
        }
      : { laboratory_id: data.laboratory_id || "" }),

    current_address: {
      post_code: data.post_code || "",
      address: data.address || "",
      building: data.building || "",
      health_area: data.health_area || "",
      province_id: data.province_id || "",
      sub_district_id: data.sub_district_id || "",
      village_number: data.village_number || "",
    },
    position: roleData.position || "",

    location: {
      latitude: data.latitude || "",
      longitude: data.longitude || "",
    },

    attachment_file: roleData.attachFile || [],
  };
};

export const ServiceAdmin = async (data, permissionEmail) => {
  let body = {};
  const user_data = CheckUserData(data);
  body = { ...body, ...user_data };
  const user_name = CheckUsername(data, "ADMIN");
  body = { ...body, ...user_name };
  const address = CheckAddress(data);
  body = { ...body, ...address };
  const laser = CheckLaser(data);
  body = { ...body, ...laser };
  body = {
    ...body,
    email: data.email,
    permission: { access_to_email: permissionEmail },
  };
  let res = await adminApi.registerAdmin(body);
  if (res) {
    if (res["data"]["code"] === 200) {
      return res["data"]["message_th"] || res["data"]["message"];
    } else {
      return res["data"]["message_th"] || res["data"]["message"];
    }
  } else {
    return "กรุณาติดต่อเจ้าหน้าที่";
  }
};

export const ServicePatient = async (data, permissionEmail) => {
  let body = {};
  const user_data = CheckUserData(data);
  body = { ...body, ...user_data };
  const user_name = CheckUsername(data, "PATIENT");
  body = { ...body, ...user_name };
  const address = CheckAddress(data);
  body = { ...body, ...address };
  const laser = CheckLaser(data);
  body = { ...body, ...laser };
  body = {
    ...body,
    email: data.email,
    permission: { access_to_email: permissionEmail },
  };
  let res = await adminApi.registerPatient(body);
  if (res) {
    if (res["data"]["code"] === 200) {
      return res["data"]["message_th"] || res["data"]["message"];
    } else {
      return res["data"]["message_th"] || res["data"]["message"];
    }
  } else {
    return "กรุณาติดต่อเจ้าหน้าที่";
  }
};

export const ServiceExecutive = async (data, permissionEmail) => {
  let body = {};
  const user_data = CheckUserData(data);
  body = { ...body, ...user_data };
  const user_name = CheckUsername(data, "EXECUTIVE");
  body = { ...body, ...user_name };
  const address = CheckAddress(data);
  body = { ...body, ...address };
  const laser = CheckLaser(data);
  body = { ...body, ...laser };
  body = {
    ...body,
    email: data.email,
    permission: { access_to_email: permissionEmail },
  };
  let res = await adminApi.registerExecutive(body);
  if (res) {
    if (res["data"]["code"] === 200) {
      return res["data"]["message_th"] || res["data"]["message"];
    } else {
      return res["data"]["message_th"] || res["data"]["message"];
    }
  } else {
    return "กรุณาติดต่อเจ้าหน้าที่";
  }
};

export const ServiceMedicalPersonal = async (data, permissionEmail) => {
  let body = {};
  const user_data = CheckUserData(data);
  body = { ...body, ...user_data };
  const user_name = CheckUsername(data, "MEDICAL_PERSONNEL");
  body = { ...body, ...user_name };
  const address = CheckAddress(data);
  body = { ...body, ...address };
  const medical = CheckMedical(data, "MEDICAL_PERSONNEL");
  body = { ...body, ...medical };
  const laser = CheckLaser(data);
  body = { ...body, ...laser };
  body = {
    ...body,
    email: data.email,
    permission: { access_to_email: permissionEmail },
  };
  let res = await adminApi.registerMedical(body);
  if (res) {
    if (res["data"]["code"] === 200) {
      return res["data"]["message_th"] || res["data"]["message"];
    } else {
      return res["data"]["message_th"] || res["data"]["message"];
    }
  } else {
    return "กรุณาติดต่อเจ้าหน้าที่";
  }
};

export const ServiceHospitalPersonal = async (data, permissionEmail) => {
  let body = {};
  const user_data = CheckUserData(data);
  body = { ...body, ...user_data };
  const user_name = CheckUsername(data, "HOSPITAL_PERSONNEL");
  body = { ...body, ...user_name };
  const address = CheckAddress(data);
  body = { ...body, ...address };
  const medical = CheckHospital(data);
  body = { ...body, ...medical };
  const laser = CheckLaser(data);
  body = { ...body, ...laser };
  body = {
    ...body,
    email: data.email,
    permission: { access_to_email: permissionEmail },
  };
  let res = await adminApi.registerHospitalPersonal(body);
  if (res) {
    if (res["data"]["code"] === 200) {
      return res["data"]["message_th"] || res["data"]["message"];
    } else {
      return res["data"]["message_th"] || res["data"]["message"];
    }
  } else {
    return "กรุณาติดต่อเจ้าหน้าที่";
  }
};

export const ServiceLaboratoryAdmin = async (data, permissionEmail) => {
  // console.log("create admin lab");
  let body = {};
  const user_data = CheckUserData(data);
  body = { ...body, ...user_data };
  const user_name = CheckUsername(data, "LABORATORY_ADMIN");
  body = { ...body, ...user_name };
  const address = CheckAddress(data);
  body = { ...body, ...address };
  const medical = CheckHospital(data);
  body = { ...body, ...medical };
  const lab = CheckStaffRole(data, "LABORATORY_ADMIN");
  body = { ...body, ...lab };
  const license = CheckMedical(data, "LABORATORY_ADMIN");
  body = { ...body, ...license };
  const laser = CheckLaser(data);
  body = { ...body, ...laser };
  body = {
    ...body,
    email: data.email,
    permission: { access_to_email: permissionEmail },
  };
  let res = await adminApi.registerLaboratory(body);
  if (res) {
    if (res["data"]["code"] === 200) {
      return res["data"]["message_th"] || res["data"]["message"];
    } else {
      return res["data"]["message_th"] || res["data"]["message"];
    }
  } else {
    return "กรุณาติดต่อเจ้าหน้าที่";
  }
};

export const ServiceLaboratoryPersonal = async (data, permissionEmail) => {
  let body = {};
  const user_data = CheckUserData(data);
  body = { ...body, ...user_data };
  const user_name = CheckUsername(data, "LABORATORY_PERSONNEL");
  body = { ...body, ...user_name };
  const address = CheckAddress(data);
  body = { ...body, ...address };
  const medical = CheckHospital(data);
  body = { ...body, ...medical };
  const license = CheckMedical(data, "LABORATORY_PERSONNEL");
  body = { ...body, ...license };
  const lab = CheckStaffRole(data, "LABORATORY_PERSONNEL");
  body = { ...body, ...lab };
  const laser = CheckLaser(data);
  body = { ...body, ...laser };
  body = {
    ...body,
    email: data.email,
    permission: { access_to_email: permissionEmail },
  };
  let res = await adminApi.registerLaboratoryPersonnel(body);
  if (res) {
    if (res["data"]["code"] === 200) {
      return res["data"]["message_th"] || res["data"]["message"];
    } else {
      return res["data"]["message_th"] || res["data"]["message"];
    }
  } else {
    return "กรุณาติดต่อเจ้าหน้าที่";
  }
};

export const ServiceHospital = async (data, permissionEmail) => {
  let body = {};
  const user_data = CheckUserData(data);
  body = { ...body, ...user_data };
  const user_name = CheckUsername(data, "HOSPITAL");
  body = { ...body, ...user_name };
  const address = CheckAddress(data);
  body = { ...body, ...address };
  const medical = CheckHospital(data);
  body = { ...body, ...medical };
  const laser = CheckLaser(data);
  body = { ...body, ...laser };
  body = {
    ...body,
    email: data.email,
    permission: { access_to_email: permissionEmail },
  };
  let res = await adminApi.registerHospital(body);
  if (res) {
    if (res["data"]["code"] === 200) {
      return res["data"]["message_th"] || res["data"]["message"];
    } else {
      return res["data"]["message_th"] || res["data"]["message"];
    }
  } else {
    return "กรุณาติดต่อเจ้าหน้าที่";
  }
};

export const ServiceAll = async (data) => {
  let body = [...data];
  let res = await adminApi.registerAll(body);
  if (res) {
    return res;
  } else {
    return "กรุณาติดต่อเจ้าหน้าที่";
  }
};

export const ServiceUpdate = async (old_role, inputs, permissionEmail) => {
  const oldRoles = old_role.map((item) => item.role);
  const newRoles = inputs.role;
  const rolesToAdd = newRoles
    .filter((role) => !oldRoles.includes(role))
    .map((role) => ({ role, uid: "" }));

  const rolesToRemove = old_role.filter(
    (item) => !newRoles.includes(item.role)
  );

  const New_Role = newRoles
    .filter((role) => !oldRoles.includes(role))
    .map((role) => ({ role, uid: "" }));

  const authorityCheckResults = await Promise.all(
    newRoles.map((role) =>
      adminApi
        .CheckUserAuthority({
          role,
          pid: inputs.id_card.replace(/-/g, ""),
        })
        .then((res) => res.data)
    )
  );

  const rolesWithAccess = authorityCheckResults.filter(
    (res) => res.code === 200 && res.success
  );
  const rolesWithoutAccess = authorityCheckResults.filter(
    (res) => res.code === 200 && !res.success
  );
  if (rolesWithoutAccess.length > 0) {
    const result = [];
    for (const roleData of rolesWithoutAccess) {
      const roles = Array.isArray(roleData.data?.role)
        ? roleData.data.role
        : [roleData.data?.role];
      for (const role of roles) {
        let body = {
          ...CheckUserData(inputs),
          ...CheckUsername(inputs, role),
          ...CheckAddress(inputs),
          ...CheckLaser(inputs),
          email: inputs.email,
          role,
          permission: { access_to_email: permissionEmail },
        };
        if (
          role === "MEDICAL_PERSONNEL" ||
          role === "LABORATORY_ADMIN" ||
          role === "LABORATORY_PERSONNEL"
        ) {
          body = { ...body, ...CheckMedical(inputs, role) };
        }

        if (
          role === "HOSPITAL" ||
          role === "HOSPITAL_PERSONNEL" ||
          role === "LABORATORY_ADMIN" ||
          role === "LABORATORY_PERSONNEL"
        ) {
          body = { ...body, ...CheckHospital(inputs) };
        }

        if (role === "LABORATORY_ADMIN" || role === "LABORATORY_PERSONNEL") {
          body = { ...body, ...CheckStaffRole(inputs, role) };
        }

        result.push(body);
      }
    }

    const res = await ServiceAll(result);
    if (res["data"]["code"] === 200) {
      // delete user
      if (rolesToRemove.length > 0) {
        await Promise.all(
          rolesToRemove.map((item) =>
            adminApi.SetEnableUser({ uid: item.uid, enable: false })
          )
        );
      }
      // update information user
      if (rolesWithAccess.length > 0) {
        const allowedRoles = authorityCheckResults.map((item) => ({
          role: item.data.role,
          uid: item.data.uid,
        }));

        const filteredRoles = allowedRoles.filter((item) =>
          New_Role.some((allowed) => allowed.role === item.role)
        );

        const update_enable_true = filteredRoles.map((item) => {
          return adminApi.SetEnableUser({ uid: item.uid, enable: true });
        });

        await Promise.all(update_enable_true);

        const combinedRoles = allowedRoles.map((item) => ({
          role: item.role,
          uid: item.uid,
        }));
        delete inputs.role;

        await adminApi.UpdateUserRole(combinedRoles, inputs, permissionEmail);
      }
      return res;
    } else {
      return res;
    }
  } else if (rolesWithoutAccess.length == 0) {
    // delete user
    if (rolesToRemove.length > 0) {
      await Promise.all(
        rolesToRemove.map((item) =>
          adminApi.SetEnableUser({ uid: item.uid, enable: false })
        )
      );
    }
    // update information user
    if (rolesWithAccess.length > 0) {
      const allowedRoles = authorityCheckResults.map((item) => ({
        role: item.data.role,
        uid: item.data.uid,
      }));

      const filteredRoles = allowedRoles.filter((item) =>
        New_Role.some((allowed) => allowed.role === item.role)
      );

      const update_enable_true = filteredRoles.map((item) => {
        return adminApi.SetEnableUser({ uid: item.uid, enable: true });
      });

      await Promise.all(update_enable_true);

      const combinedRoles = allowedRoles.map((item) => ({
        role: item.role,
        uid: item.uid,
      }));
      delete inputs.role;

      // console.log("password", inputs);

      const res = await adminApi.UpdateUserRole(
        combinedRoles,
        inputs,
        permissionEmail
      );

      if (res) {
        return res;
      } else {
        return "กรุณาติดต่อเจ้าหน้าที่";
      }
    }
  }
};

export const ServiceCreate = async (inputs, permissionEmail) => {
  const result = [];
  for (const roleData of inputs?.role || []) {
    const roles =
      typeof roleData === "object" && roleData?.data?.role
        ? [roleData.data.role]
        : [roleData];
    for (const role of roles) {
      let body = {
        ...CheckUserData(inputs),
        ...CheckUsername(inputs, role),
        ...CheckAddress(inputs),
        ...CheckLaser(inputs),
        email: inputs.email,
        role,
        permission: { access_to_email: permissionEmail },
      };
      if (
        role === "MEDICAL_PERSONNEL" ||
        role === "LABORATORY_ADMIN" ||
        role === "LABORATORY_PERSONNEL"
      ) {
        body = { ...body, ...CheckMedical(inputs, role) };
      }

      if (
        role === "HOSPITAL" ||
        role === "HOSPITAL_PERSONNEL" ||
        role === "LABORATORY_ADMIN" ||
        role === "LABORATORY_PERSONNEL"
      ) {
        body = { ...body, ...CheckHospital(inputs) };
      }

      if (role === "LABORATORY_ADMIN" || role === "LABORATORY_PERSONNEL") {
        body = { ...body, ...CheckStaffRole(inputs, role) };
      }

      result.push(body);
    }
  }

  const res = await ServiceAll(result);

  return res;
};

// export const ServiceUpdate = async (old_role, inputs, permissionEmail) => {
//   const oldRoles = old_role.map((item) => item.role);
//   const newRoles = inputs.role;

//   const New_Role = newRoles
//     .filter((role) => !oldRoles.includes(role))
//     .map((role) => ({ role, uid: "" }));

//   const Delete_role = old_role.filter((item) => !newRoles.includes(item.role));

//   const Update_role = old_role.filter((item) => newRoles.includes(item.role));

//   if(Delete_role.length > 0){
//     const update_enable_false = Delete_role.map((item) => {
//       return adminApi.SetEnableUser({ uid: item.uid, enable: false });
//     });

//     const res_delete = await Promise.all(update_enable_false);

//   }

//   const CheckAuth = await Promise.all(
//     inputs.role.map(async (role) => {
//       const res = await adminApi.CheckUserAuthority({
//         role,
//         pid: inputs.id_card.replace(/-/g, ""),
//       });
//       return res["data"];
//     })
//   );

//   const hasRoleTrue = CheckAuth.some(
//     (item) => item.code === 200 && item.success === true
//   );
//   const hasRoleFalse = CheckAuth.some(
//     (item) => item.code === 200 && item.success === false
//   );

//   let res_enable_true = [];
//   let res_service_calls = [];
//   let update_information = [];

//   if (hasRoleTrue) {
//     const allowedRoles = CheckAuth.map((item) => ({
//       role: item.data.role,
//       uid: item.data.uid,
//     }));

//     const filteredRoles = allowedRoles.filter((item) =>
//       New_Role.some((allowed) => allowed.role === item.role)
//     );

//     const update_enable_true = filteredRoles.map((item) => {
//       return adminApi.SetEnableUser({ uid: item.uid, enable: true });
//     });

//     await Promise.all(update_enable_true);

//     const combinedRoles = allowedRoles.map((item) => ({
//       role: item.role,
//       uid: item.uid,
//     }));
//     delete inputs.role;

//     await adminApi.UpdateUserRole(
//       combinedRoles,
//       inputs,
//       permissionEmail
//     );
//   }

//   if (hasRoleFalse) {
//     const failedRoles = CheckAuth.filter(
//       (item) => item.code === 200 && item.success === false
//     );

//     console.log(1);

//     if (!inputs.password) {
//       return { error: "กรุณากรอกรหัสผ่าน" };
//     } else if (!inputs.confirm_password) {
//       return { error: "กรุณายืนยันรหัสผ่าน" };
//     } else if (inputs.password !== inputs.confirm_password) {
//       return { error: "กรุณากรอกรหัสผ่านให้ตรงกัน" };
//     }

//     console.log("create new role", inputs);

//     res_service_calls = await Promise.all(
//       failedRoles.map(async (item) => {
//         const role = item.data.role;
//         if (role === "ADMIN") return ServiceAdmin(inputs);
//         if (role === "PATIENT") return ServicePatient(inputs);
//         if (role === "EXECUTIVE") return ServiceExecutive(inputs);
//         if (role === "MEDICAL_PERSONNEL") return ServiceMedicalPersonal(inputs);
//         if (role === "HOSPITAL_PERSONNEL")
//           return ServiceHospitalPersonal(inputs);
//         if (role === "LABORATORY_ADMIN") return ServiceLaboratoryAdmin(inputs);
//         if (role === "LABORATORY_PERSONNEL")
//           return ServiceLaboratoryPersonal(inputs);
//         if (role === "HOSPITAL") return ServiceHospital(inputs);
//       })
//     );
//   }

//   return {
//     enabled_roles: res_enable_true,
//     failed_role_services: res_service_calls,
//     update_information: update_information["data"],
//   };
// };
